import { a as r } from "./array-from-constructor-and-list.js";
import { t } from "./typed-array-species-constructor.js";
var o = function o(_o, s) {
  return r(t(_o), s);
};
export { o as t };